import { WorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { WorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDisclosure } from '@/hooks';
import { Button, Tooltip } from 'antd';
import React from 'react';
import WorkOrderReviewEtiquetteModal from './WorkOrderReviewEtiquetteModal';

interface Props {
  workOrder?: WorkOrder;
  complement?: WorkOrderComplement;
}

export default function WorkOrderReviewEtiquetteButton({
  workOrder,
  complement,
}: Props) {
  const [opened, action] = useDisclosure();

  const hasLicensePlate = !!workOrder?.vehicle?.licensePlate;

  return (
    <>
      <Tooltip
        title={!hasLicensePlate ? 'Não há veículo vinculado' : undefined}
      >
        <Button block disabled={!hasLicensePlate} onClick={action.open}>
          Etiqueta de Revisão
        </Button>
      </Tooltip>

      {opened && (
        <React.Suspense fallback={<></>}>
          <WorkOrderReviewEtiquetteModal
            open={opened}
            onCancel={action.close}
            workOrder={workOrder}
            complement={complement}
          />
        </React.Suspense>
      )}
    </>
  );
}
